export const HOUR_LIMITS = {
    maxHoursPerWeek: 40
};



// WEBPACK FOOTER //
// ./src/constants/hours.ts